import { Translate, useFormController } from '@dreryk/react-common';
import { Form, StrongText, StyledFlex } from '@dreryk/react-components';

import { translationKeys } from '../../../translations';

import {
   PredefinedPatientGroupsUpdateFormBean,
   PredefinedPatientGroupsUpdateFormController,
   PredefinedPatientGroupsUpdateFormInitializer,
} from './PredefinedPatientGroupsUpdateForm.types';
import { PredefinedPatientGroupsPatientPortalField } from './fields/PredefinedPatientGroupsPatientPortalField';

type PredefinedPatientGroupsUpdateFormRenderProps = Pick<
   PredefinedPatientGroupsUpdateFormController,
   'handleSubmit' | 'formState'
>;

type PredefinedPatientGroupsUpdateFormProps = {
   children: (renderProps: PredefinedPatientGroupsUpdateFormRenderProps) => JSX.Element;
   initializer: PredefinedPatientGroupsUpdateFormInitializer;
};

export const PredefinedPatientGroupsUpdateForm = (props: PredefinedPatientGroupsUpdateFormProps): JSX.Element => {
   const { register, handleSubmit, formState } = useFormController<PredefinedPatientGroupsUpdateFormBean>(
      props.initializer()
   );

   return (
      <Form noValidate autoComplete={false}>
         <StyledFlex gap={8} direction={'column'}>
            <StrongText testId={'label'}>
               <Translate>{translationKeys.blockRegistrationViaFollowingPortals}</Translate>
            </StrongText>

            <PredefinedPatientGroupsPatientPortalField register={register} />
         </StyledFlex>

         {props.children({
            handleSubmit: handleSubmit,
            formState: formState,
         })}
      </Form>
   );
};
